import { navLinks } from '@/mocks/homeData';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg flex items-center justify-center bg-primary-500 text-background-50">
                <i className="ri-cup-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold">茶杯狐影视</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-50/60">
              关于茶杯狐影视的平台入口与最新地址说明站，涵盖官网入口、官方网址、发布页与永久入口等关联内容。
            </p>
          </div>

          <div>
            <h2 className="font-heading text-sm font-semibold text-background-50/90">页面分区</h2>
            <ul className="mt-4 grid grid-cols-2 gap-x-8 gap-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-50/60 hover:text-primary-200 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm font-semibold text-background-50/90">入口提醒</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-background-50/60">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-300"></i>
                <span>以官方公布的最新地址为准</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-300"></i>
                <span>收藏发布页，长期防走失</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-300"></i>
                <span>核对信息，警惕仿冒页面</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-10 md:mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            © {year} 茶杯狐影视 · 本页为入口信息整理与说明，具体可用地址以官方公布为准
          </p>
          <a href="#top" className="text-xs text-background-50/50 hover:text-primary-200 transition-colors cursor-pointer">
            返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}